import { Link, Text } from "@simplybusiness/mobius";

interface StickyFooterTextProps {
  headlineText: string;
  descriptionText: string;
  disclaimerUrl?: string;
}

export const StickyFooterText = ({
  headlineText,
  descriptionText,
  disclaimerUrl,
}: StickyFooterTextProps) => (
  <div className="sticky-footer__text">
    <Text elementType="p" variant="h4" className="sticky-footer__headline">
      {headlineText}
    </Text>
    <Text elementType="p" className="sticky-footer__description">
      {descriptionText}
    </Text>
    {disclaimerUrl && (
      <Link href={disclaimerUrl} className="sticky-footer__disclaimer">
        Terms and conditions
      </Link>
    )}
  </div>
);
